import * as React from "react";
interface Props {
  fill?: string;
  fill1?: string;
  fill2?: string;
}
export const Logo = (props: Props | any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 100}
    height={props.height ?? 100}
    fill="none"
    viewBox="0 0 100 100"
    {...props}
  >
    <path
      fill="url(#a)"
      d="M43.807.129c-.06.07-.2.38-.32.68-.27.74-.55 1.02-1.21 1.24-1.2.39-1.2.911-.01 1.261.61.18.95.54 1.22 1.27.38 1.031.81 1.031 1.15.01.241-.7.561-1.05 1.181-1.24 1.281-.42 1.301-.81.06-1.26-.69-.25-1-.59-1.26-1.35-.09-.271-.2-.551-.26-.621-.12-.16-.42-.16-.55.01Z"
    />
    <path
      fill="url(#b)"
      d="M21.077.76c-.49 1.29-.67 1.49-1.57 1.78-.591.2-.761.35-.711.68.02.18.16.28.68.46.83.3 1.11.57 1.39 1.371.181.5.291.67.471.71.33.08.39.02.68-.75.32-.83.53-1.03 1.361-1.33.52-.18.66-.28.68-.46.05-.33-.13-.491-.75-.671-.7-.2-1.04-.54-1.32-1.3-.12-.33-.28-.63-.34-.671-.24-.15-.48-.08-.571.18Z"
    />
    <path
      fill="url(#c)"
      d="M54.623 1.85c-.49.21-1.501 1.64-2.642 3.721-.15.28-.24.32-1.15.48-1.14.2-2.931.69-3.352.901-.39.21-.62.68-.54 1.11.08.44 1.03 1.851 2.041 3.032.45.51.81.98.81 1.05 0 .06-.06.47-.14.92-.08.451-.2 1.351-.26 2.002-.14 1.48-.04 1.9.52 2.17.34.17.41.17 1.011.03.76-.18 2.01-.6 3.101-1.06l.78-.32 1.071.45c1.16.49 2.421.91 3.082 1.02.54.08 1.08-.14 1.28-.54.24-.45.2-2-.1-4.311-.06-.45-.05-.46.73-1.331 1.001-1.13 2.002-2.521 2.142-2.981.16-.52-.09-1.01-.64-1.281-.43-.21-2.392-.71-3.582-.91-.65-.11-.66-.12-.88-.58C57.233 4.04 55.962 2.2 55.462 1.9c-.38-.23-.42-.24-.84-.05Zm1.02 4.662c.33.66.67 1.27.75 1.34.08.08.84.3 1.691.49.84.19 1.561.37 1.591.4.03.04-.45.571-1.07 1.201l-1.121 1.14.06.481c.13 1.17.25 2.771.22 2.802-.02.02-.64-.23-1.37-.56-.73-.33-1.421-.601-1.531-.601-.11 0-.69.22-1.29.5-.591.27-1.201.53-1.341.56-.22.06-.24.04-.2-.17.03-.13.13-.84.21-1.58.19-1.571.28-1.321-1.09-2.762-.521-.55-.921-1.03-.881-1.06.04-.04.75-.21 1.57-.39.83-.18 1.581-.37 1.681-.42.1-.05.46-.65.79-1.341.34-.68.64-1.24.68-1.24.03 0 .331.54.651 1.21Z"
    />
    <path
      fill="url(#d)"
      d="M31.232 2.27c-3.052.71-5.223 2.641-6.203 5.542-1.51 4.433 1.09 9.305 5.652 10.595 1.081.31 2.642.37 3.702.16 3.092-.63 5.243-2.57 6.313-5.712.21-.62.24-.87.24-2.301 0-1.401-.03-1.691-.23-2.351-.7-2.211-2.12-3.992-3.912-4.903-.52-.26-1.19-.24-1.51.05-.56.5-.45 1.34.23 1.881.23.17.76.66 1.18 1.08 1.24 1.211 1.791 2.532 1.791 4.243 0 1.66-.49 2.861-1.64 4.012-1.211 1.21-2.512 1.7-4.263 1.61-2.48-.13-4.522-1.75-5.242-4.162-.21-.71-.21-2.37-.01-3.151.4-1.53 1.6-3.032 2.961-3.702.4-.2 1.11-.47 1.571-.6.93-.27 1.16-.43 1.32-.92.16-.47-.03-1.001-.44-1.251-.3-.18-1-.24-1.51-.12Z"
    />
    <path
      fill="url(#e)"
      d="M15.424 8.083c-.54.34-1.47 1.62-2.22 3.071-.37.73-.39.75-.831.81-.79.1-3.342.73-3.682.91-.33.17-.62.581-.62.881 0 .44.88 1.741 2.17 3.232.341.4.631.81.631.9-.01.09-.07.46-.15.82-.09.36-.18 1.241-.22 1.951-.08 1.851.11 2.161 1.25 2.021.48-.06 1.941-.53 3.162-1.02.78-.31.62-.33 2.321.33.56.22 1.39.49 1.861.62.78.21.86.21 1.21.06.27-.11.42-.26.52-.5.17-.41.19-1.46.05-2.611-.24-1.991-.28-1.73.411-2.511.81-.91 1.971-2.461 2.141-2.872.28-.68-.11-1.23-1.08-1.52-.29-.09-1.201-.3-2.031-.48l-1.511-.32-.57-1.061c-.68-1.25-1.481-2.351-1.951-2.661-.41-.28-.48-.28-.86-.05Zm1.851 5.722c.12.06.82.25 1.58.41.751.17 1.402.33 1.452.36.05.03-.39.54-.99 1.141l-1.081 1.08.12 1.521c.07.83.1 1.541.07 1.571-.02.03-.64-.21-1.36-.53-1.492-.66-1.271-.67-2.972.1-.57.26-1.05.46-1.07.44-.02-.02.03-.54.11-1.14.24-1.991.29-1.841-.861-3.052-.55-.58-.99-1.09-.97-1.15.02-.05.23-.13.48-.18.92-.17 2.35-.48 2.55-.56.13-.06.441-.561.841-1.351l.64-1.271.63 1.25c.351.7.721 1.301.831 1.361Z"
    />
    <path
      fill="url(#f)"
      d="M43.267 10.454c-.31.17-.58.62-.58.95 0 .35.29.86.56.99.8.36 1.631-.12 1.641-.96 0-.83-.91-1.38-1.62-.98Z"
    />
    <path
      fill="url(#g)"
      d="M36.034 10.594c-.28.12-.38.27-.6.86-.31.88-.87 1.5-1.761 1.951-.7.36-.81.5-.77.96.02.31.1.43.38.62.42.28.76.24 1.64-.2 1.221-.62 2.171-1.94 2.241-3.13.03-.531.01-.631-.2-.821-.28-.26-.65-.35-.93-.24Z"
    />
    <path
      fill="url(#h)"
      d="M24.178 17.877c-.91.81-.01 2.291 1.1 1.831.571-.24.861-1 .591-1.53-.32-.631-1.16-.771-1.69-.3Z"
    />
    <path
      fill="url(#i)"
      d="M61.006 18.047c-.87.48-.5 1.861.5 1.861.36 0 .8-.31.95-.66.36-.85-.62-1.661-1.45-1.2Z"
    />
    <path
      fill="url(#j)"
      d="M46.429 18.958c-.23.25-.82 1.02-1.31 1.7-3.192 4.512-5.633 9.585-6.844 14.237-.32 1.25-.36 1.89-.15 2.311.38.72 1.56.66 1.97-.11.06-.11.241-.71.391-1.33 1.24-4.893 3.762-9.995 7.273-14.687.78-1.06.86-1.311.58-1.911-.19-.4-.62-.66-1.11-.66-.32 0-.44.07-.8.45Z"
    />
    <path
      fill="url(#k)"
      d="M32.943 20.258c-.61.56-.59.28-.6 8.554 0 8.104 0 8.194.5 8.734.55.6 1.16.47 1.56-.33l.28-.55v-7.734c0-8.344.01-8.123-.52-8.694-.3-.32-.86-.31-1.22.02Z"
    />
    <path
      fill="url(#l)"
      d="M29.2 21.539c-.06.07-.2.37-.31.68-.26.69-.39.81-1.26 1.16-1.02.41-.99.781.07 1.181.6.22.87.52 1.18 1.28.23.561.28.621.55.621.271 0 .321-.06.551-.62.32-.79.6-1.08 1.24-1.29 1.131-.37 1.131-.811 0-1.181-.61-.2-.95-.54-1.19-1.21-.1-.281-.23-.561-.28-.631-.12-.16-.42-.16-.55.01Z"
    />
    <path
      fill="url(#m)"
      d="M50.13 21.479c-.07.05-.19.3-.28.58-.23.67-.6 1.29-.88 1.47-.13.08-.45.23-.73.32-1.09.391-1.05.371-1.05.681 0 .25.06.32.48.49.26.11.64.28.85.37.5.2.8.61 1.21 1.591.29.72.34.78.6.78.33 0 .37-.07.671-.89.31-.85.85-1.4 1.65-1.66.641-.22.971-.5.871-.76-.02-.07-.36-.25-.75-.401-.91-.34-1.29-.69-1.62-1.46-.151-.35-.321-.741-.391-.881-.13-.25-.43-.36-.63-.23Zm.34 3.141c-.02.06-.08.1-.13.1s-.11-.04-.13-.1c-.02-.06.04-.11.13-.11s.15.05.13.11Z"
    />
    <path
      fill="url(#n)"
      d="M22.818 23.85c-.42.42-.45.91-.11 1.48.76 1.271 1.69 2.922 1.95 3.432 1.001 2.011 2.042 5.073 2.522 7.384.25 1.21.4 1.52.83 1.66.4.14.75.03 1.06-.3.28-.31.27-.84-.05-2.27-.79-3.542-2.18-6.984-4.141-10.266-.9-1.52-1.4-1.78-2.061-1.12Z"
    />
    <path
      fill="url(#o)"
      d="M15.214 25.05c-.91.91.11 2.311 1.25 1.711.16-.08.361-.31.461-.51.35-.73-.2-1.54-1.03-1.54-.25 0-.43.09-.68.34Z"
    />
    <path
      fill="url(#p)"
      d="M37.475 25.28c-.27.761-.34.901-.57 1.151-.14.15-.56.39-.931.53-1.01.39-1.01.76.01 1.15.71.281 1.06.611 1.26 1.241.21.65.32.78.62.74.21-.02.3-.15.531-.72.16-.38.34-.76.42-.83.07-.08.45-.27.83-.42.63-.25.691-.31.691-.57 0-.26-.06-.31-.75-.59-.8-.33-.83-.36-1.291-1.481-.16-.39-.24-.47-.46-.47-.19 0-.28.07-.36.27Z"
    />
    <path
      fill="url(#q)"
      d="M21.167 27.282c-.09.1-.28.49-.43.86-.36.85-.83 1.28-1.691 1.52-.74.2-.87.3-.87.62 0 .251.04.271 1.13.681.68.24 1.1.7 1.43 1.57.331.861.411.981.641.981.25 0 .45-.28.65-.92.1-.32.33-.76.53-.99.34-.4 1.181-.89 1.531-.89.22 0 .51-.351.47-.571-.02-.12-.26-.26-.75-.43-1-.35-1.3-.6-1.65-1.391-.46-1.04-.53-1.16-.69-1.19-.08-.01-.22.05-.301.15Zm.41 2.87c0 .02-.03.11-.06.2-.09.231-.34.201-.34-.04 0-.13.07-.2.2-.2.11 0 .2.02.2.04Z"
    />
    <path
      fill="url(#r)"
      d="M13.553 33.915c-3.01.75-5.582 1.44-5.702 1.52-.13.09-1.35 2.121-2.771 4.593-1.401 2.44-3.092 5.392-3.762 6.543-.67 1.16-1.26 2.25-1.3 2.43-.1.49.25 1.151.73 1.351.31.14 2.75.81 5.002 1.38l.52.131v8.014c0 5.732.03 8.123.11 8.364.16.47.54.96.89 1.14.16.09 2.272.72 4.673 1.41a3565.343 3565.343 0 0 1 17.988 5.193c3.252.95 3.342.97 3.742.9.37-.06 1.75-.45 13.066-3.651 3.522-1 7.684-2.171 9.254-2.611 1.571-.44 3.092-.87 3.382-.95.66-.19 1.19-.641 1.43-1.221.18-.41.19-.84.19-8.564v-8.124l2.632-.69c1.44-.38 2.751-.75 2.901-.82.42-.21.69-.701.63-1.161-.02-.23-.42-1.04-1.02-2.101-1.64-2.892-5.583-9.885-5.973-10.595-.42-.75-.82-1.13-1.29-1.23-.18-.04-2.602-.631-5.373-1.311-2.781-.68-5.212-1.271-5.412-1.301-.73-.12-1.321.43-1.321 1.22 0 .48.19.85.55 1.081.12.08 1.33.43 2.691.78 1.371.35 2.482.65 2.482.68 0 .04-14.097 3.572-18.029 4.513l-.86.21-4.542-1.11c-10.055-2.462-14.387-3.542-14.387-3.602 0-.03 1.09-.34 2.431-.69 1.33-.35 2.571-.7 2.751-.791.41-.2.62-.59.62-1.19 0-.39-.05-.51-.34-.8-.27-.271-.41-.341-.72-.331-.22 0-2.851.63-5.863 1.39Zm45.022 4.832c.32.56 1.03 1.81 1.57 2.771.54.96 1.621 2.871 2.401 4.252.91 1.59 1.381 2.521 1.311 2.561-.06.04-1.64.46-3.512.94-3.021.771-7.683 1.982-9.764 2.542-7.724 2.06-8.434 2.231-8.574 2.04-.15-.21-.63-1-2.391-3.98-.71-1.212-1.891-3.212-2.622-4.433-.73-1.23-1.31-2.251-1.29-2.261.02-.02 2.621-.67 5.782-1.45 3.162-.781 8.144-2.012 11.056-2.742 2.921-.73 5.332-1.32 5.372-1.3.03.02.33.49.66 1.06Zm-43.53.36c5.332 1.33 10.824 2.691 14.666 3.622.97.23 1.77.46 1.77.5 0 .04-.88 1.55-1.96 3.361-1.08 1.801-2.481 4.162-3.111 5.233-.63 1.07-1.211 2.01-1.281 2.081-.1.11-.94-.08-4.812-1.08-2.582-.66-5.093-1.321-5.593-1.461-.49-.13-3.281-.85-6.193-1.591-2.911-.74-5.302-1.36-5.332-1.38-.02-.02.32-.64.75-1.381.43-.74 1.59-2.742 2.571-4.442 2.491-4.352 2.791-4.853 2.872-4.853.04 0 2.58.63 5.652 1.391Zm24.26 15.057c.68 1.16 1.361 2.181 1.501 2.291.58.43.88.39 5.183-.78 4.692-1.28 12.225-3.252 12.395-3.252.08 0 .1 2.121.09 7.424l-.03 7.423-1.3.37a7791.906 7791.906 0 0 1-18.909 5.343c-1.7.48-3.181.89-3.271.91-.17.05-.18-.65-.18-13.626V46.59l1.64 2.742c.9 1.51 2.191 3.681 2.882 4.832Zm-7.063 19.75c-.03.02-.67-.14-1.43-.37-.76-.231-6.013-1.732-11.686-3.352L8.821 67.25l-.03-7.363c-.02-6.243 0-7.364.12-7.364.13 0 .88.2 6.563 1.701 2.221.58 3.572.94 7.854 2.051 2.161.56 2.581.57 3.111.04.27-.28 1.821-2.801 5.423-8.864l.37-.61.03 13.516c.01 7.423 0 13.526-.02 13.556Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={44.085}
        x2={44.085}
        y1={5.355}
        y2={0}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="b"
        x1={21.427}
        x2={21.427}
        y1={5.788}
        y2={0.501}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="c"
        x1={54.989}
        x2={54.989}
        y1={17.373}
        y2={1.716}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="d"
        x1={32.767}
        x2={32.767}
        y1={18.691}
        y2={2.207}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="e"
        x1={15.794}
        x2={15.794}
        y1={22.775}
        y2={7.916}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="f"
        x1={43.788}
        x2={43.788}
        y1={12.516}
        y2={10.32}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="g"
        x1={35.035}
        x2={35.035}
        y1={15.163}
        y2={10.548}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="h"
        x1={24.888}
        x2={24.888}
        y1={19.795}
        y2={17.598}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="i"
        x1={61.525}
        x2={61.525}
        y1={19.908}
        y2={17.914}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill1 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="j"
        x1={43.241}
        x2={43.241}
        y1={37.712}
        y2={18.507}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="k"
        x1={33.513}
        x2={33.513}
        y1={37.921}
        y2={20.004}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="l"
        x1={29.477}
        x2={29.477}
        y1={26.461}
        y2={21.41}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="m"
        x1={50.364}
        x2={50.364}
        y1={27.762}
        y2={21.424}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="n"
        x1={25.873}
        x2={25.873}
        y1={37.866}
        y2={23.509}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="o"
        x1={15.948}
        x2={15.948}
        y1={26.906}
        y2={24.71}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="p"
        x1={37.777}
        x2={37.777}
        y1={30.099}
        y2={25.011}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="q"
        x1={21.369}
        x2={21.369}
        y1={33.514}
        y2={27.13}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
      <linearGradient
        id="r"
        x1={33.583}
        x2={33.583}
        y1={76.909}
        y2={32.523}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={props.fill1 ?? props.fill} />
        <stop offset={1} stopColor={props.fill2 ?? props.fill} />
      </linearGradient>
    </defs>
  </svg>
);
